import React from 'react';
import SubpageHero from '../components/SubpageHero';
import { useTarievenHero } from '../hooks/useTarievenHero';
import PriceListSection from '../components/PriceListSection';
import LooseTreatmentsSection from '../components/LooseTreatmentsSection';
import ImageModule from '../components/ImageModule';
import { getCurrentLocale } from '../services/api';

const Tarieven: React.FC = () => {
  const { data: heroData, loading: heroLoading } = useTarievenHero();
  const locale = getCurrentLocale();
  const isArabic = locale === 'ar';

  const fallbackHero = (
    <div
      className="fallback-hero"
      style={{
        height: '560px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-start',
        padding: '0 120px 80px 120px',
      }}
    >
      <h1
        style={{
          fontFamily: 'var(--h1-font-family)',
          fontWeight: 'var(--h1-font-weight)',
          fontStyle: 'var(--h1-font-style)',
          fontSize: 'var(--h1-font-size)',
          lineHeight: 'var(--h1-line-height)',
          letterSpacing: 'var(--h1-letter-spacing)',
          color: 'white',
          margin: '0',
          textAlign: isArabic ? 'right' : 'left',
          width: '100%',
        }}
      >
        {isArabic ? 'الأسعار' : 'Tarieven'}
      </h1>
    </div>
  );

  const attributes = heroData?.data?.attributes;

  return (
    <div dir={isArabic ? 'rtl' : 'ltr'}>
      {!heroLoading && attributes ? (
        <SubpageHero
          title={attributes.title}
          backgroundMedia={
            attributes.backgroundMedia?.data
              ? {
                  url: attributes.backgroundMedia.data.attributes.url,
                  alternativeText: attributes.backgroundMedia.data.attributes.alternativeText,
                }
              : undefined
          }
          mediaType={attributes.mediaType}
          videoUrl={attributes.videoUrl}
          overlayOpacity={attributes.overlayOpacity}
          textColor={attributes.textColor}
          paddingBottom={attributes.paddingBottom}
          paddingLeft={attributes.paddingLeft}
          paddingRight={attributes.paddingRight}
        />
      ) : (
        fallbackHero
      )}

      <PriceListSection />
      <LooseTreatmentsSection />
      <ImageModule title={isArabic ? 'وحدة الأسعار' : 'Tarieven Module'} />
    </div>
  );
};

export default Tarieven; 